import { createSlice, PayloadAction } from "@reduxjs/toolkit";

//エントリーフォームの値格納 Slice
// タイプの定義
export type InputFormTypes = {
  jsondata: string,
  pageno: number,
  name: string,
  submitDialogOpen: boolean,
  submitDialogOkButton: boolean,
  submitDialogMessage: string,

};
  
// 初期ステート
const initialState: InputFormTypes = {
  jsondata: "",
  pageno: 1,
  name: "お申込者",
  submitDialogOpen: false, // trueだとダイアログを開く, falseだと閉じる
  submitDialogOkButton: true, //trueだとOKが押せない, falseだと押せる
  submitDialogMessage: "",
}

export type SetInputFormPayload = {
  jsondata: string,
  pageno: number,
  name: string,
  submitDialogOpen: boolean,
  submitDialogOkButton: boolean,
  submitDialogMessage: string,
};

// アクションとリデューサの定義
const inputFormSlice = createSlice({
  name: "inputform",
  initialState,
  reducers: {
    // 送信JSONデータの設定
    setJsondata: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        jsondata: action.payload
      }
    },

    // ページ番号
    setPageno: (state, action: PayloadAction<number>) => {
      return {
        ...state,
        pageno: action.payload
      }
    },

    // 申込者名
    setName: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        name: action.payload
      }
    },

    // 送信ダイアログの表示
    setSubmitDialogOpen: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        submitDialogOpen: action.payload
      }
    },

    // 送信ダイアログのOKボタン
    setSubmitDialogOkButton: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        submitDialogOkButton: action.payload
      }
    },


    // 送信ダイアログのメッセージ
    setSubmitDialogMessage: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        submitDialogMessage: action.payload
      }
    },

  }
});

// リデューサのエクスポート
export default inputFormSlice.reducer;

// アクションのエクスポート
export const { setJsondata, setPageno, setName, setSubmitDialogOpen, setSubmitDialogOkButton, setSubmitDialogMessage } = inputFormSlice.actions;